module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedHeavy.f24785c.woff";